import styled from 'styled-components'

import { avatarPlaceholder } from './images'

export const Avatar = styled.img.attrs((props: { src?: string }) => ({
  src: props.src ?? avatarPlaceholder
}))`
  border-radius: 50%;
  outline: none;
  width: 46px;
  height: 46px;
`
